import React from 'react';

export const LazyTbmStatusPage = React.lazy(() => import('./TbmStatusPage'));
export const LazyTbmAttendancePage = React.lazy(() => import('./TbmAttendancePage'));
export const LazyTbmMonitoringPage = React.lazy(() => import('./TbmMonitoringPage'));
export const LazyTbmManagementPage = React.lazy(() => import('./TbmManagementPage'));
